import { onMount } from "@/modules/_";

import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  let mm = gsap.matchMedia();

  onMount(() => {
    const staggerAmount = element.getAttribute("data-stagger-amount");
    const duration = element.getAttribute("data-duration");

    mm.add("(min-width: 768px)", () => {
      gsap.from(element.children, {
        opacity: 0,
        y: 20,
        duration: duration ? Number(duration) : 2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
          start: "top 90%",
          // markers: true,
        },
        stagger: {
          amount: staggerAmount ? Number(staggerAmount) : 0.5,
          from: "start",
          grid: "auto",
        },
        onComplete: () => {
          Array.from(element.children).forEach((child) => {
            const childElement = child as HTMLElement;
            childElement.style.removeProperty("transform");
            childElement.style.removeProperty("opacity");
            childElement.style.removeProperty("translate");
            childElement.style.removeProperty("scale");
            childElement.style.removeProperty("rotate");
          });
        },
      });
    });
  });
}
